<template>
  <div>
    <page-navigate></page-navigate>
    <div id="pageContainer">
      <section class="container1">
        <div class="flex contentBox justify-between items-center">
          <div class="left">
            <h1 class="super_large-80_bold md-title-32_bold">交易产品</h1>
            <h2 class="subtitle-20_regular md-body-14_regular">
              超百种热门金融产品和极具竞争力的机构定价，带您进入全球最受欢迎
              <br class="pc" />且流动性最高的市场，随时掌控最佳交易机会
            </h2>
            <a :href="signupUrl" target="_blank">
              <div class="primary-default_large iBtn">
                立即开户
                <span class="iconfont icon-right"></span>
              </div>
            </a>
          </div>
          <img
            class="right"
            src="@/assets/image/trading-product/newProductContainer1.png"
            alt=""
          />
        </div>
      </section>
      <div class="floatTab flex justify-center items-center ">
        <div
          class="
            tabItem
            text-center
            cursor-pointer
            body-16_regular
            active
            word1
          "
        >
          衍生品交易
        </div>
        <div class="tabItem text-center cursor-pointer body-16_regular word2">
          贵金属及能源
        </div>
        <div class="tabItem text-center cursor-pointer body-16_regular word3">
          全球股指
        </div>
        <div class="tabItem text-center cursor-pointer body-16_regular word4">
          美国股票
        </div>
        <div class="tabItem text-center cursor-pointer body-16_regular word5">
          ETF
        </div>
        <div class="tabItem text-center cursor-pointer body-16_regular word6">
          数字资产
        </div>
      </div>
      <div class="mobile scrollTabWrapper ">
        <div class="scrollTab flex justify-center items-center">
          <div
            class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              active
              word1
            "
          >
            衍生品交易
          </div>
          <div
            class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              word2
            "
          >
            贵金属及能源
          </div>
          <div
            class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              word3
            "
          >
            全球股指
          </div>
          <div
            class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              word4
            "
          >
            美国股票
          </div>
          <div
            class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              word5
            "
          >
            ETF
          </div>
          <div
            class="
              tabItem
              text-center
              cursor-pointer
              md-footnote-regular_12
              word6
            "
          >
            数字资产
          </div>
        </div>
      </div>
      <section class="container2">
        <div class="contentBox container2Content">
          <h2 class="container2H2 text-center title-48_bold md-title-24_bold scroll-fade-up">
            最低 0 点差即可交易<br class="mobile" /> 37 种货币对
          </h2>
          <h2 class="container2H2 text-center title-48_bold md-title-24_bold scroll-fade-up">
            想投资组合多元化，<br class="pc" />贵金属及能源会是您的理想选择
          </h2>
          <h2 class="container2H2 text-center title-48_bold md-title-24_bold scroll-fade-up">
            为您甄选全球主流指数，积极探索<br class="pc" />全球经济中最有价值和最活跃的领域
          </h2>
          <h2 class="container2H2 text-center title-48_bold md-title-24_bold scroll-fade-up">
            美国股票CFDs，轻松将<br class="pc" />世界顶级公司纳入您的投资组合
          </h2>
          <h2 class="container2H2 text-center title-48_bold md-title-24_bold scroll-fade-up">
            ETF CFDs 一站式交易<br class="pc" />全球热门板块与行业指数
          </h2>
          <h2 class="container2H2 text-center title-48_bold md-title-24_bold scroll-fade-up">
            最高200倍杠杆<br class="pc">超低门槛全天候交易
          </h2>
          <div id="pageOverLay"></div>
          <product-module-new />
          <div class="footnote-regular_12 footerTip scroll-fade-up">*加密货币实行分级杠杆机制，持仓量不同杠杆等级不同，详询客服了解。</div>
          <a
            href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/EBC%20PRODUCT%20GUIDE_CN.pdf"
            target="_blank"
          >
            <div class="iBtn primary-default_large scroll-fade-up">交易产品指南</div>
          </a>
        </div>
      </section>
      <open-account></open-account>
    </div>
    <message-v3></message-v3>
    <page-footer></page-footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import fadeAnimate from "../mixins/fadeAnimate.js";
export default {
  mixins: [fadeAnimate],
  mounted() {
    document.documentElement.setAttribute("data-fitter", "true");
    document
      .querySelectorAll(`.message-new p`)
      .forEach((i) => (i.innerHTML = "全球最佳券商<br/>成就赢家之旅"));
   
    const setTabActIdx = (idx, e) => {
      scrollTabElement.forEach((item, index) => {
        item.classList.remove("active");
      });
      floatTabElement.forEach((item, index) => {
        item.classList.remove("active");
      });
      floatTabElement[idx].classList.add("active");
      scrollTabElement[idx].classList.add("active");
      const rem = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );
      const leftPad = 32 * rem;
      const wrapper = document.querySelector(".scrollTabWrapper");
      wrapper.scrollLeft = idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
    };
     
    const scrollTabElement = document.querySelectorAll(
      ".scrollTabWrapper .tabItem"
    );
    const floatTabElement = document.querySelectorAll(".floatTab .tabItem");
    floatTabElement.forEach((item, idx) => {
      item.addEventListener("click", function (e) {
         if(idx == 5){
                  document.querySelector('.footerTip').classList.add('showFooterTip')
                }else {
                  document.querySelector('.footerTip').classList.remove('showFooterTip')
                }
        setTabActIdx(idx, e);
        ProductVM.changeHandle(idx);
        setContentH2(idx);
      });
    });
    scrollTabElement.forEach((item, idx) => {
      item.addEventListener("click", function (e) {
        if(idx == 5){
                  document.querySelector('.footerTip').classList.add('showFooterTip')
                }else {
                  document.querySelector('.footerTip').classList.remove('showFooterTip')
                }
        setTabActIdx(idx, e);
        ProductVM.changeHandle(idx);
        setContentH2(idx);
      });
    });
    function setContentH2(idx) {
      let contentH2List = document.querySelectorAll(
        ".container2Content .container2H2"
      );
      
      contentH2List.forEach((i, index) => {
        i.style.display = "none";
      });
      contentH2List[idx].style.display = "block";
    }
    setContentH2(0);
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const goIndex = params.get('index') || 0;
    ProductVM.changeHandle(goIndex);
    let domList = window.matchMedia("(max-width: 996px)").matches  ? document.querySelectorAll(
      ".scrollTabWrapper .tabItem"
    ) :  document.querySelectorAll(".floatTab .tabItem")
    setTabActIdx(goIndex, {target:domList[goIndex]});
    setContentH2(goIndex)
  },
  destroyed() {
    document.documentElement.removeAttribute("data-fitter");
  },
  computed: {
    ...mapGetters(["signupUrl"]),
  },
};
</script>

<style scoped>
@import url("../assets/css/rem.css");

.message-new .gender-btn::before{
  box-sizing: border-box;
}
.message-new{
  max-width: 1200rem;
  padding-inline:calc((100vw - 1200rem) / 2)!important;
  box-sizing: content-box;
}
.message-new  .p1{
font-size: 48rem!important;
line-height: 56rem!important; 
}
.contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}
::v-deep .contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}
body.no-scroll {
  overflow: hidden;
}
#pageOverLay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  display: none;
  opacity: 0;
  transition: opacity 0.6s ease;
}
.pageContainer{
  position: relative;
}
#pageContainer {
  background:var(--ebc-neutral-bg_a)
}
::v-deep #pageContainer .iBtn {
  gap: 4rem;
  min-width: 180rem;
  width: fit-content;
  cursor:pointer;
}
#pageContainer a{
  width: fit-content;
  display: block;
  margin-inline:auto;
}
.container1 {
  padding-top: calc(80px + 15rem);
  height: 560rem;
  background: var(--ebc-neutral-bg_c);
}
.container1 .left{
  flex:0 0 770rem;
}
.container1 .left h2 {
  margin: 24rem 0 64rem;
  color: var(--ebc-text-secondary);
}


.container1 .right {
  height: 412rem;
}
.container1 a{
  margin:0!important;
}
.footerTip{
  display: none;
  color: var(--ebc-text-tertiary);
  margin-top: 24rem;
  width: 996rem;
  margin-inline: auto;
}
.showFooterTip{
  display: block;
}
@media (max-width: 996px) {
.footerTip{
  margin-top: 32rem;
  width: 100%;
}
  html{
  overflow-x:hidden;
}
body{
  overflow-x:visible!important;
}
.message-new  .p1{
font-size: 48rem!important;
line-height: 72rem!important; 
}
  .container1 {
    padding: 80rem 32rem;
    height: auto;
    overflow-x: hidden;
  }
  .container1 .right{
    /* width: 586rem; */
    height: 586rem;
    margin: 0 auto 80rem;
  }
  .container1 > div {
    flex-direction: column;
  }
  .container1 .left {
    order: 2;
    text-align: center;
    flex:1;
  }
  .container1 .left h2 {
    margin-top: 16rem;
  }
  #pageContainer .container1 a{
    width: 100%;
  }
  #pageContainer .container1 .left .iBtn {
    width: 100%;
  }
 
}


.container2{
  background:var(--ebc-neutral-bg_a);
  margin-top: -64rem;
}

 .floatTab{
  position: sticky;
  transform:translateY(-50%);
  z-index: 99999;
  top:128px;
  margin-inline:auto;
  background:var(--ebc-basecolor-white-85);
  border-radius: var(--ebc-corner-radius-full);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  padding:4rem;
  gap:8rem;
  width: 792rem;
  height:64rem;
}

 .floatTab .tabItem{
  flex:1;
  color: var(--ebc-text-secondary);
}
 .floatTab .active{
    border-radius: var(--ebc-corner-radius-full);
    background: var(--ebc-neutral-bg_c);
    color:var(--ebc-text-primary);
    display:flex;
    align-items: center;
    justify-content: center;
    height:100%;
    font-weight: 500;
}
.container2 .container2Content{
  padding:120rem 0;
}
.container2 h2 {
  margin-bottom: 16rem;
}
.container2 h3{
  margin:16rem 0;
  color:var(--ebc-text-secondary);
}

.container2 .iBtn{
  margin: 60rem auto 0;
}

@media (max-width: 996px) {
  .container2 {
    padding:0 32rem;
    margin-top: 0;
  }
  .container2 .container2Content .btnTop{
  height:64rem;
  font-size: 28rem;
  gap:8rem;
  line-height: 44rem;
}
   .container2 .iBtn{
    height:80rem;
    font-size: 28rem;
    line-height: 44rem;
    margin-top: 80rem;
  }
  .floatTab{
    display:none!important;
  }
  .container2 .container2Content{
    padding:64rem 0 160rem;
  }
  .container2 h3{
    margin:16rem 0;
  }
   .scrollTab{
    display: inline-flex;
    gap:16rem;
    min-width: fit-content;
  }
  .scrollTabWrapper{
    overflow-x: auto;
    scroll-behavior: smooth;
    padding:16rem 32rem;
    margin-top: 64rem;
    background: var(--ebc-neutral-bg_a);
    position: sticky;
    top:44px;
    z-index:99;
  }
    .scrollTabWrapper::-webkit-scrollbar {
    display: none;
  }
   .scrollTab .tabItem{
    color:var(--ebc-text-secondary);
    padding:16rem 32rem;
    flex:1;
    background: var(--ebc-neutral-bg_b);
    border-radius: var(--ebc-corner-radius-full);
    white-space: nowrap;
  }
   .scrollTab .active{
    background:var(--ebc-basecolor-active-500);
    color:var(--ebc-text-primary_white);
    font-weight: 500;
  }
}



.container4 {
  padding:120rem 0;
  background: var(--ebc-basecolor-white-100);
  text-align: center;
}
.container4 .QA-list{
  margin-top: 60rem;
}
.container4 .QA-list .QA-item{
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 24rem;
}
.container4 .QA-list .QA-item .QA-title span:first-child{
  display: inline;
}
.container4 .QA-list .QA-item .QA-title span:nth-child(2){
  display: none;
}
.container4 .QA-list .QA-item.showList .QA-title span:first-child{
  display: none;
}
.container4 .QA-list .QA-item.showList .QA-title span:nth-child(2){
  display: inline;
}
.container4 .QA-list .QA-item .QA-content{
 height:0;
  overflow: hidden;
}
.container4 .QA-list .QA-item.showList .QA-content{
 height:auto;
}
.container4 .QA-list .QA-title{
  text-align: left;
  display: flex;
  cursor: pointer;
}
.ar .container4 .QA-list .QA-title span{
  margin-left: unset;
  margin-right: auto;
}
.container4 .QA-list .QA-title span{
  margin-left: auto;
  font-size: 28rem;
}
.container4 .QA-list .QA-li{
  text-align: left;
  color: var(--ebc-text-secondary);
  position: relative;
  padding-left: 18rem; 
  margin-top:10rem;
}
.container4 .QA-list .QA-li:first-child{
  margin-top: 24rem;
}
.container4 .QA-list .QA-li::before {
  content: "•";
  position: absolute;
  left: 0;
  top: 14rem; /* 根据 line-height 调整，使其在第一行中间 */
  transform: translateY(-50%);
  font-size: 16rem;
  line-height: 0;
  color:var(--ebc-text-secondary)
}

@media (max-width: 996px) {
  .container4{
    padding:160rem 32rem;
  }
  .container4 .QA-list{
    margin-top: 80rem;
  }
  .container4 .QA-list .QA-item{
    padding:40rem 0;
  }
  .container4 .QA-list .QA-title span{
  font-size: 42rem;
}
.container4 .QA-list .QA-li{
  padding-left:32rem;
  margin-top: 25rem;
  
}
.container4 .QA-list .QA-li:first-child{
  margin-top: 40rem;
}
.container4 .QA-list .QA-li::before {
  top: 24rem; /* 根据 line-height 调整，使其在第一行中间 */
  transform: translateY(-50%);
  font-size: 32rem;
}
}
</style>
